import { apiCall } from "./index";

export const getRoles = () => apiCall("/roles");

export const createRole = (roleData) => apiCall("/roles", "POST", roleData);

export const updateRole = (roleId, roleData) =>
  apiCall(`/roles/${roleId}`, "PUT", roleData);

export const deleteRole = (roleId) => apiCall(`/roles/${roleId}`, "DELETE");
